import { render, staticRenderFns } from "./MediaCoverage1.vue?vue&type=template&id=647cacb8&scoped=true"
import script from "./MediaCoverage1.vue?vue&type=script&lang=js"
export * from "./MediaCoverage1.vue?vue&type=script&lang=js"
import style0 from "./MediaCoverage1.vue?vue&type=style&index=0&id=647cacb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647cacb8",
  null
  
)

export default component.exports